import { render, staticRenderFns } from "./CarSupplierXnySale.vue?vue&type=template&id=37763876"
import script from "./CarSupplierXnySale.vue?vue&type=script&lang=js"
export * from "./CarSupplierXnySale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports